import React, { useState } from 'react';
import { Button, Col, Modal, Row, Typography, message } from 'antd';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { TScene } from '../../../../models/objects/objects';
import { getImagePath } from '../../../../utils/format/valueFormat';

const { Title, Paragraph, Text } = Typography;

interface SceneHelpProps {
    scenesConfig: TScene[];
    open: boolean;
    onClose: () => void;
}

const SceneHelp: React.FC<SceneHelpProps> = ({ scenesConfig, open, onClose }) => {
    const [globalCopied, setGlobalCopied] = useState(false);
    const [copiedId, setCopiedId] = useState<number | null>(null);

    const handleGlobalCopy = () => {
        navigator.clipboard.writeText('// Pour sélectionner une scene\nsetScene("Nom de la scene");');
        setGlobalCopied(true);
        message.success('Code copié !');
        setTimeout(() => setGlobalCopied(false), 2000);
    };

    const handleCopyScene = (sceneName: string, id: number) => {
        navigator.clipboard.writeText(`setScene("${sceneName}");`);
        setCopiedId(id);
        message.success('Code copié !');
        setTimeout(() => setCopiedId(null), 2000);
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width="90%"
            centered
            // ⬇️ Empêche le modal de grandir et active le scroll interne
            styles={{
                body: {
                    maxHeight: 'calc(100vh - 220px)', // ajuste si besoin (header/footer)
                    overflowY: 'auto',
                    paddingRight: 12, // évite le "layout shift" avec la barre de scroll
                },
                content: {
                    margin: 0, // optionnel, évite des marges parasites
                },
            }}
        >
            <Title level={3}>Scènes</Title>

            <div
                style={{
                    background: '#fafafa',
                    padding: 16,
                    borderRadius: 8,
                    marginBottom: 24,
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
            >
                <Paragraph>
                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                        <code>{`// Pour sélectionner une scene\nsetScene("Nom de la scene");`}</code>
                    </pre>
                </Paragraph>
                <Button icon={globalCopied ? <CheckOutlined /> : <CopyOutlined />} onClick={handleGlobalCopy}>
                    {globalCopied ? 'Copié' : 'Copier'}
                </Button>
            </div>

            <Row gutter={[24, 24]} justify="start">
                {scenesConfig
                    .filter(scene => scene.img !== '')
                    .map(scene => (
                        <Col key={scene.id} xs={12} sm={8} md={6} lg={4} xl={3}>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                                    backgroundColor: '#fff',
                                    padding: 12,
                                    borderRadius: 8,
                                }}
                            >
                                <div
                                    style={{
                                        width: 150,
                                        height: 150,
                                        borderRadius: 8,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginBottom: 8,
                                        overflow: 'hidden',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            backgroundImage: `url(${getImagePath(scene.img)})`,
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat',
                                            backgroundPosition: 'center',
                                        }}
                                    />
                                </div>
                                <Text strong>{scene.name}</Text>
                                <Button
                                    icon={copiedId === scene.id ? <CheckOutlined /> : <CopyOutlined />}
                                    onClick={() => handleCopyScene(scene.name, scene.id)}
                                    style={{ marginTop: 8 }}
                                >
                                    {copiedId === scene.id ? 'Copié' : 'Copier'}
                                </Button>
                            </div>
                        </Col>
                    ))}
            </Row>
        </Modal>
    );
};

export default SceneHelp;
